import React, { useGlobal, Fragment } from 'reactn';
import { Link } from 'react-router-dom';
import { Avatar, Menu, MenuItem, Box, BoxProps } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { logOut } from 'meta/util';
import ColoredButton from 'components/ColoredButton';
import theme from 'meta/theme';

interface Props {
	boxProps?: BoxProps;
	hideName?: boolean;
}

const UserMenu: React.FC<Props> = ({ boxProps, hideName }) => {
	const [user] = useGlobal('user');
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	if (user) {
		return (
			<Fragment>
				<Box {...boxProps}>
					<ColoredButton
						hoverBgColor={theme.palette.primary.dark}
						bgColor={theme.palette.primary.main}
						size="small"
						onClick={handleClick}
					>
						<Box marginRight="10px">
							<Avatar
								style={{ height: '35px', width: '35px' }}
								src={user.avatar}
								alt=""
							/>
						</Box>
						{user.username}
						<ExpandMoreIcon />
					</ColoredButton>
				</Box>

				<Menu
					style={{ marginTop: 25 }}
					onClose={handleClose}
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClick={handleClose}
				>
					<MenuItem component="a" href="/account">
						My Account
					</MenuItem>
					<MenuItem component="a" onClick={logOut}>
						Logout
					</MenuItem>
				</Menu>
			</Fragment>
		);
	}

	return (
		<ColoredButton
			hoverBgColor="#5c6ba5"
			bgColor="#667ac1"
			size="small"
			component={Link}
			to="/login"
			color="secondary"
		>
			Log In With Discord
		</ColoredButton>
	);
};

export default UserMenu;
